<fgb-page-header [pageTitle]="'rewards.wallet.claimed.reward.title'" [showBalance]="false" />

<div class="container">
  <div class="pt-20 pb-20 d-none d-lg-block">
    <div class="glass-back-button" [routerLink]="'/rewards/wallet'">
      <span class="material-symbols-outlined text-white cursor-pointer"> arrow_back_ios_new </span>
    </div>
  </div>

  <div>
    <fgbcl-lottos-wallet-details></fgbcl-lottos-wallet-details>
  </div>
</div>
